import React from 'react';
import { useParams } from 'react-router-dom';
import PagamentiTable from '../components/pagamentiTable';

function Pagamenti() {
  const { id } = useParams();
  return (
    <div>
      <PagamentiTable cantiereId={id} />
    </div>
  );
}

export default Pagamenti;
